import GlobalRequest from '@/http/GlobalRequest'
import ErrorResponseHandler from '@/utility/ErrorResponseHandler'

const global = {
  namespaced: true,
  state: {
    settings: [],
  },
  getters: {
    getSettings: (state) => {
      return state.settings
    },
  },
  actions: {
    getSettings: ({ commit }) => {
      const request = new GlobalRequest()
      request
        .get()
        .then((res) => {
          commit('setSettings', res.data)
        })
        .catch((err) => {
          ErrorResponseHandler.redirectErrorPage(err.response)
        })
    },
  },
  mutations: {
    setSettings(state, settings) {
      state.settings = settings
    },
  },
}

export default global
